<template>
<div class="contentBox liveStatistics">
    <div class="pageTitle">
        <!--<h1>监控统计</h1>-->
        <el-steps :active="3" simple finish-status="wait" style="padding-left: 0">
            <el-step title="编辑" icon="el-icon-edit" @click.native="jumpNavPage('/live/edit')"></el-step>
            <el-step title="发起直播" icon="el-icon-video-play" @click.native="jumpNavPage('/live/launch')"></el-step>
            <el-step title="分享" icon="el-icon-share" @click.native="jumpNavPage('/live/share')"></el-step>
            <el-step title="监控统计" icon="el-icon-data-analysis"></el-step>
            <el-step title="录播" icon="el-icon-video-camera" @click.native="jumpNavPage('/live/history')"></el-step>
        </el-steps>
    </div>
    <div class="overviewBox">
        <div class="videoInfo">
            <i class="videoBtn" @click="playLive" v-if="statInfo.liveStatus === 'LIVING'"></i>
            <div class="videoListImgIcon">
                <img :src="statInfo.poster" alt="" />
            </div>
            <div class="videoListText">
                <a herf="javascript:;" class="liveName">
                    {{statInfo.title}}
                </a>
                <div class="liveTime">创建时间：{{statInfo.createTime}}</div>
            </div>
            <el-button type="primary" size="medium" @click="playLive" icon="el-icon-video-play" v-if="statInfo.liveStatus === 'LIVING'">播放</el-button>
        </div>
        <div class="balance">
            <div class="item">
                <span class="title">流量</span>
                <div class="number">{{statInfo.formatedFlow}} <span>{{statInfo.formatedFlowUnit}}</span></div>
            </div>
            <div class="item">
                <span class="title">空间</span>
                <div class="number">{{statInfo.formatedSpace}} <span>{{statInfo.formatedSpaceUnit}}</span></div>
            </div>
            <div class="item last">
                <span class="title">时长</span>
                <div class="number">{{statInfo.formatedDuration}} <span>H</span></div>
            </div>
        </div>
    </div>
    <div class="MonitorStatistical">
        <el-tabs v-model="activeTab" type="card" @tab-click="handleClick">
            <el-tab-pane label="访问统计" name="STAT">
                <div class="statistPrompt" v-if="statistPromptFlag">
                    <img src="../../assets/rulesTips.svg" class="SPIcon" alt="" />
                    <div class="SPText">
                        以下统计数据支持90天内在线查询统计，90天后数据将被清除。如需保存数据，请使用图表的导出功能将数据导出本地保存。
                    </div>
                    <img src="../../assets/nodeCloseBtn.svg" class="SPCloseBtn" @click="deleteStatistPrompt()" />
                </div>
                <el-card shadow="never" style="margin-right: 10px">
                    <div slot="header" class="clearfix">
                        <span>统计时段</span>
                    </div>
                    <el-row :gutter="12">
                        <el-col :span="14">
                            <el-radio-group v-model="statRange">
                                <el-radio-button v-for="item in PRESET_RANGE" :label="item" :key="item"></el-radio-button>
                            </el-radio-group>
                        </el-col>
                        <el-col :span="10" style="border-left: 1px solid #e8e8e8" v-if="statRange === '自定义'">
                            <el-date-picker
                                    v-model="customRange"
                                    type="datetimerange"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束事件"
                                    range-separator="至">
                            </el-date-picker>
                        </el-col>
                    </el-row>
                </el-card>
                <div class="advanceds">
                    <div class="title">
                        <span>访问次数</span>
                    </div>
                    <v-chart autoresize :option="statPvOption" class="line-chart"/>
                </div>
                <div class="advanceds">
                    <div class="title">
                        <span>绝对用户数</span>
                    </div>
                    <v-chart autoresize :option="statUvOption" class="line-chart"/>
                </div>
                <div class="advanceds">
                    <div class="title">
                        <span>带宽</span>
                    </div>
                    <v-chart autoresize :option="statBandwdithOption" class="line-chart"/>
                </div>
                <div class="advanceds">
                    <div class="title">
                        <span>地域统计</span>
                    </div>
                    <v-chart autoresize :option="statCityMapOption" class="line-chart" style="height: 600px"/>
                </div>
            </el-tab-pane>
            <el-tab-pane label="实时监控" name="MONITOR">
                <div class="advanceds">
                    <div class="title">
                        <span>独立用户数</span>
                    </div>
                    <!--<div ref="linechart1" :style="{ width: '1210px', height: '370px' }" class="linechart"></div>-->
                    <v-chart autoresize :option="monitorUvOption" class="line-chart"/>
                </div>
                <div class="advanceds">
                    <div class="title">
                        <span>流量</span>
                    </div>
                    <v-chart autoresize :option="monitorBandwidthOption" class="line-chart"/>
                </div>
            </el-tab-pane>
            <el-tab-pane label="禁言用户" name="MUTEUSER">
                <div class="advanceds">
                    <el-table
                            :data="muteUsers"
                            border
                            style="width: 100%">
                        <el-table-column
                                fixed
                                prop="name"
                                label="用户"
                                width="300px">
                        </el-table-column>
                        <el-table-column
                                prop="muteTime"
                                label="到期时间"
                                width="400px">
                        </el-table-column>
                        <el-table-column
                                fixed="right"
                                label="操作">
                            <template slot-scope="scope">
                                <el-button @click="cancelMute(scope.row)" type="text" size="small">解除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
    <el-drawer
            title="直播播放"
            :visible.sync="showPlayer"
            :wrapperClosable="false"
            size="640px"
            @close="playerClosed">
        <div class="chat-container">
            <vue-aliplayer-v2 :source="source" ref="AliplayerV2" :options="playerOptions"/>
            <div class="chat-room">
                <div style="width: 100%" >
                    <template v-for="(msg, index) in chatMessages">
                        <div class="chatItem chatLeft" :key="index">
                            <img v-if="['system', 'instruction'].includes(msg.type)" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAI5SURBVFhHzZiJkoMgEEQx9/X/X5pU7mT3sbYLxmNQ3NpXRcUDmaaBQVOcTqe3+0ckC3q/4+r186IoyqMf6ud9mAUpML+LxcKX2WzmAyoo916vl3s+n+7xePhj3bMK6xUkITS4Wq28ECs8e7vd3P1+j4R30SmIBinr9dotl8vyajq0cT6fo861MSt/P9DD+/1+lBhAwG638+2ok200CuIBGkGMxWYrDDluJwlSZXo0BbiEsDZRkSAqUbbbbXllGhDECm0S9eGQKk+NOl0XVUXWDQT9FU2LJbLCuppYwuSXJstT0FwK24kcsgoiE5PsvnOYu16v5dVh1BOtF4QYbQN9aDtQYYs4Ho/esSHUTagcms/n5VE3ob2hMDmGwBSI2zhkY1aWRMHlcvFzLBWJShYU9qYOomiHYWUYrW6FsYfb0oEcwy2Gsg+5C5MIkosESnldgUoQNucAMRQm65DNOVlQWwAJAbaFzWbjj1OpBJHshhAKIfPiijWFNOEF0WscUsNdUFciVJgnOV7koHKIQJYVES5RhBwOB//SlYvf1r+xpn/mCI7kEhKOTOQQxbJZjpkjfUQOAcOWKwVYIR5mQCRILg3Zi3Lx4ZCUsnNPAfOULUXzJpw/0PqhqIpM4DFvAiEIYcOl00oXQA6UEaYvVxLemHdt5ohcUWB1GHQNzN/2gKiU5IcQhkiuhIHb6BUkJIxflj12M5ThcHIPEfr3g/NqKAxiwCxIhI5BeF4PahURkixoavIsn2w49wXP1nvKq1VotgAAAABJRU5ErkJggg==" alt="" class="user"/>
                            <img :src="msg.user.portrait" alt="" v-else class="user"/>
                            <div class="chat">
                                <p class="name" v-if="msg.user && msg.user.mode === 'sponsor'"><span class="tag">主播</span> {{ msg.user.name }} </p>
                                <p class="name" v-else-if="msg.user && msg.user.mode === 'normal'">
                                    <el-dropdown>
                                          <span class="el-dropdown-link">
                                            {{ msg.user.name }}<i class="el-icon-arrow-down el-icon--right"></i>
                                          </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item @click.native="muteUser(msg.user, 1)">禁言一天</el-dropdown-item>
                                            <el-dropdown-item @click.native="muteUser(msg.user, 3)">禁言三天</el-dropdown-item>
                                            <el-dropdown-item @click.native="muteUser(msg.user, 7)">禁言一周</el-dropdown-item>
                                            <el-dropdown-item @click.native="muteUser(msg.user, 30)">禁言一个月</el-dropdown-item>
                                            <el-dropdown-item @click.native="muteUser(msg.user, 999999)">永久禁言</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </p>
                                <div v-if="msg.type === 'image'" class="img"><img :src="msg.message" alt=""></div>
                                <p v-else class="text" v-html="msg.message"></p>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <el-card shadow="never" :body-style="{padding: '12px'}" class="input-panel">
                <el-row>
                    <el-input type="textarea"
                              v-model.trim="chatInput"
                              :autosize="{ minRows: 2, maxRows: 4}"
                              show-word-limit
                              maxlength=256
                              @keydown.ctrl.enter.native="sendMessage"></el-input>
                </el-row>
                <el-row style="margin-top: 8px">
                    <el-button type="primary" @click="sendMessage()">发送</el-button>
                    <el-button type="primary" icon="el-icon-picture-outline" circle @click="$refs.chat_file.click()"></el-button>
                    <input type="file" ref="chat_file" accept="image/png, image/jpeg, image/gif, image/jpg" class="webuploader" multiple="multiple" v-bind="chatFile"
                           @change="handleFileChange">
                </el-row>
            </el-card>
        </div>
    </el-drawer>
</div>
</template>
<script>
    import common from '../../common.vue';
    import moment from 'moment';
    import 'moment/locale/zh-cn';

    // echarts相关
    import VChart from 'vue-echarts'
    import * as echarts from 'echarts'
    import {use} from 'echarts/core'
    import {CanvasRenderer} from 'echarts/renderers'
    import 'echarts/extension/bmap/bmap';
    import {LineChart, MapChart, LinesChart, ScatterChart, EffectScatterChart} from 'echarts/charts'
    import {
        GridComponent,
        TooltipComponent,
        MarkPointComponent,
        MarkLineComponent,
        GraphicComponent,
        GeoComponent,

    } from 'echarts/components'

    use([
        CanvasRenderer,
        LineChart,
        LinesChart,
        MapChart,
        ScatterChart,
        EffectScatterChart,
        GridComponent,
        TooltipComponent,
        MarkPointComponent,
        MarkLineComponent,
        GraphicComponent,
        GeoComponent
    ]);

    const RESULT_MSG_MAPPER = {"0": '', '1': '登录已过期', '2': '无效的频道', '3': '访问被拒绝'};
    // 直播监控数据刷新步长
    const MONITOR_STEP = 30000;
    // 统计图表最多点数
    const MAX_STAT_POINT = 200;
    // 自定义时间段
    const CUSTOM_TYPE = 23;
    /**
     * 热力图最大点尺寸
     */
    const MAX_POINT_SIZE = 28;
    /**
     * 最大消息个数
     */
    const MAX_MESSAGE_COUNT = 2000;
    /**
     * 文件最大大小
     */
    const MAX_FILE_SIZE = 30;
    /**
     * 图片最大宽度
     */
    const MAX_IMG_WIDTH = 320;
    /**
     * 禁言结果
     */
    const MUTE_RESULT_MAPPER = {"0": '', '-1': '登录已过期', '-2': '访问被拒绝', '-3': '该用户已被执行更长禁言'};
    /**
     * 禁言超过该时间显示为永久
     */
    const FOREVER_THRESHOLD = 20 * 365 * 24 * 3600000;
    // 热点放大倍率
    let heatScale = 20;

    /**
     * 从当前时间前移时长，单位秒
     * SLS每分钟入库一次，>=60较为安全
     */
    const PADDING = 60;
    export default {
        name: "Statistics",
        components: {
            VChart
        },
        data() {
            return {
                // 预定义的统计时间段
                PRESET_RANGE : ['今天','昨天','一天','本周','一周','本月','30天','3个月','自定义'],
                // 显示的监控还是统计
                activeTab: "STAT",
                // 统计时间段
                statRange: '今天',
                // 自定义时间段
                customRange: [],
                statistPromptFlag: true,
                /* 统计图表  */
                // 统计PV
                statPvOption:{
                    tooltip: {
                        trigger: 'axis'
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            dataView: {readOnly: true},
                            saveAsImage: {}
                        }
                    },
                    xAxis: {
                        type: 'time'
                    },
                    yAxis: {
                        type: 'value',
                        boundaryGap: [0, '10%']
                    },
                    series: [
                        {
                        name: '访问次数',
                        type: 'line',
                        data: [],
                        showSymbol: false,
                        itemStyle: {
                            normal: {
                                lineStyle: {
                                    color: '#8cd5c2'
                                }
                            }
                        },
                        markPoint: {
                            data: [
                                {type: 'max', name: '最大值'}
                            ]
                        },
                        markLine: {
                            data: [
                                {type: 'average', name: '平均值'}
                            ]
                        }
                    }]
                },
                // 统计UV
                statUvOption:{
                    tooltip: {
                        trigger: 'axis'
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            dataView: {readOnly: true},
                            saveAsImage: {}
                        }
                    },
                    xAxis: {
                        type: 'time'
                    },
                    yAxis: {
                        type: 'value',
                        boundaryGap: [0, '10%']
                    },
                    series: [{
                        name: '绝对用户数',
                        type: 'line',
                        data: [],
                        showSymbol: false,
                        itemStyle: {
                            normal: {
                                lineStyle: {
                                    color: '#ee6666'
                                }
                            }
                        },
                        markPoint: {
                            data: [
                                {type: 'max', name: '最大值'}
                            ]
                        },
                        markLine: {
                            data: [
                                {type: 'average', name: '平均值'}
                            ]
                        }
                    }]
                },
                // 统计带宽
                statBandwdithOption:{
                    tooltip: {
                        trigger: 'axis',
                        position: function (pt) {
                            return [pt[0], '10%'];
                        },
                        formatter: function (params) {
                            let param = params[0], time = new Date(param.value[0]), flow = param.value[1].toFixed(2);
                            return moment(time).format('MM-DD HH:mm') + ' 带宽： ' + flow + "M";
                        }
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            dataView: {readOnly: true},
                            saveAsImage: {}
                        }
                    },
                    xAxis: {
                        type: 'time'
                    },
                    yAxis: {
                        type: 'value',
                        name: '带宽（单位M）',
                        boundaryGap: [0, '10%']
                    },
                    series: [{
                        title: '带宽',
                        type: 'line',
                        data: [],
                        lineStyle: {
                            width: 0
                        },
                        markLine: {
                            data: [
                                {type: 'average', name: '平均值'}
                            ]
                        },
                        showSymbol: false,
                        areaStyle: {opacity: 0.8,
                            color: echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(0, 221, 255)'
                            }, {
                                offset: 1,
                                color: 'rgba(77, 119, 255)'
                            }])}
                    }]
                },
                // 城市地域分布配置
                statCityMapOption: {
                    backgroundColor: 'transparent',
                    title: {
                        text: '用户地域分布',
                        subtext: '城市分布',
                        left: 'center',
                        textStyle: {
                            color: '#fff'
                        }
                    },
                    tooltip: {
                        trigger: 'item'
                    },
                    bmap: {
                        center: [104.114129, 37.550339],
                        zoom: 5,
                        roam: true,
                        mapStyle: {
                            styleJson: [
                                {
                                    featureType: 'water',
                                    elementType: 'all',
                                    stylers: {
                                        color: '#044161'
                                    }
                                },
                                {
                                    featureType: 'land',
                                    elementType: 'all',
                                    stylers: {
                                        color: '#004981'
                                    }
                                },
                                {
                                    featureType: 'boundary',
                                    elementType: 'geometry',
                                    stylers: {
                                        color: '#064f85'
                                    }
                                },
                                {
                                    featureType: 'railway',
                                    elementType: 'all',
                                    stylers: {
                                        visibility: 'off'
                                    }
                                },
                                {
                                    featureType: 'highway',
                                    elementType: 'geometry',
                                    stylers: {
                                        color: '#004981'
                                    }
                                },
                                {
                                    featureType: 'highway',
                                    elementType: 'geometry.fill',
                                    stylers: {
                                        color: '#005b96',
                                        lightness: 1
                                    }
                                },
                                {
                                    featureType: 'highway',
                                    elementType: 'labels',
                                    stylers: {
                                        visibility: 'off'
                                    }
                                },
                                {
                                    featureType: 'arterial',
                                    elementType: 'geometry',
                                    stylers: {
                                        color: '#004981'
                                    }
                                },
                                {
                                    featureType: 'arterial',
                                    elementType: 'geometry.fill',
                                    stylers: {
                                        color: '#00508b'
                                    }
                                },
                                {
                                    featureType: 'poi',
                                    elementType: 'all',
                                    stylers: {
                                        visibility: 'off'
                                    }
                                },
                                {
                                    featureType: 'green',
                                    elementType: 'all',
                                    stylers: {
                                        color: '#056197',
                                        visibility: 'off'
                                    }
                                },
                                {
                                    featureType: 'subway',
                                    elementType: 'all',
                                    stylers: {
                                        visibility: 'off'
                                    }
                                },
                                {
                                    featureType: 'manmade',
                                    elementType: 'all',
                                    stylers: {
                                        visibility: 'off'
                                    }
                                },
                                {
                                    featureType: 'local',
                                    elementType: 'all',
                                    stylers: {
                                        visibility: 'off'
                                    }
                                },
                                {
                                    featureType: 'arterial',
                                    elementType: 'labels',
                                    stylers: {
                                        visibility: 'off'
                                    }
                                },
                                {
                                    featureType: 'boundary',
                                    elementType: 'geometry.fill',
                                    stylers: {
                                        color: '#029fd4'
                                    }
                                },
                                {
                                    featureType: 'building',
                                    elementType: 'all',
                                    stylers: {
                                        color: '#1a5787'
                                    }
                                },
                                {
                                    featureType: 'label',
                                    elementType: 'all',
                                    stylers: {
                                        visibility: 'off'
                                    }
                                }
                            ]
                        }
                    },
                    series: [
                        {
                            name: '用户数',
                            type: 'scatter',
                            coordinateSystem: 'bmap',
                            data: [],
                            encode: {
                                value: 2
                            },
                            symbolSize: function (val) {
                                return val[2] * heatScale;
                            },
                            label: {
                                formatter: '{b}',
                                position: 'right'
                            },
                            itemStyle: {
                                color: '#ddb926'
                            },
                            emphasis: {
                                label: {
                                    show: true
                                }
                            }
                        },
                        {
                            name: '前三名',
                            type: 'effectScatter',
                            coordinateSystem: 'bmap',
                            data: [],
                            encode: {
                                value: 2
                            },
                            symbolSize: function (val) {
                                return val[2] * heatScale;
                            },
                            showEffectOn: 'emphasis',
                            rippleEffect: {
                                brushType: 'stroke'
                            },
                            hoverAnimation: true,
                            label: {
                                formatter: '{b}',
                                position: 'right',
                                show: true
                            },
                            itemStyle: {
                                color: '#f4e925',
                                shadowBlur: 10,
                                shadowColor: '#333'
                            },
                            zlevel: 1
                        }
                    ]
                },
                // 直播监控用户数线性图option
                monitorUvOption: {
                    tooltip: {
                        trigger: 'axis',
                        formatter: function (params) {
                            let param = params[0], time = new Date(param.value[0]);
                            return time.getHours() + ':' + time.getMinutes() + ':' + time.getSeconds() + ' : ' + param.value[1];
                        },
                        axisPointer: {
                            animation: false
                        }
                    },
                    xAxis: {
                        type: 'time'
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        type: 'line',
                        data: [],
                        showSymbol: false,
                        itemStyle: {
                            normal: {
                                lineStyle: {
                                    color: '#8cd5c2'
                                }
                            }
                        },
                        markPoint: {
                            data: [
                                {type: 'max', name: '最大值'}
                            ]
                        },
                        markLine: {
                            data: [
                                {type: 'average', name: '平均值'}
                            ]
                        }
                    }]
                },
                // 直播监控带宽线性图
                monitorBandwidthOption: {
                    tooltip: {
                        trigger: 'axis',
                        position: function (pt) {
                            return [pt[0], '10%'];
                        },
                        formatter: function (params) {
                            var param = params[0], time = new Date(param.value[0]), flow = param.value[1].toFixed(2);
                            return time.getHours() + ':' + time.getMinutes() + ':' + time.getSeconds() + ' : ' + flow + "M";
                        }
                    },
                    xAxis: {
                        type: 'time'
                    },
                    yAxis: {
                        type: 'value',
                        name: '带宽（单位M）'
                    },
                    series: [{
                        title: '带宽',
                        type: 'line',
                        data: [],
                        lineStyle: {width: 0},
                        markLine: {data: [{type: 'average', name: '平均值'}]},
                        showSymbol: false,
                        areaStyle: {
                            opacity: 0.8,
                            color: echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(0, 221, 255)'
                            }, {
                                offset: 1,
                                color: 'rgba(77, 119, 255)'
                            }])
                        }
                    }]
                },
                // 刷新数据的timer
                monitorTimer: null,
                // 实时监控数据请求起始点
                realTimeFrom: 0,
                // 概要统计信息
                statInfo: {},
                // 是否显示播放直播边栏
                showPlayer: false,
                // 播放器配置
                playerOptions: {isLive: true},
                // 直播链接
                source: '',
                // 互动输入内容
                chatInput: '',
                // 聊天室配置
                chatConfig: {},
                // 聊天室ws
                webSocket: null,
                // 是否发送保持连接信息
                sendPing: true,
                // 发送保持连接信息好的timer
                pingTimer: null,
                // 聊天室是否在线
                online: false,
                // 聊天要发送的照片文件
                chatFile: null,
                // 聊天消息
                chatMessages: [],
                // 禁言用户列表
                muteUsers: []
            };
        },
        methods: {
            changeTab(tab) {
                this.currentTab = tab;
            },
            // 播放直播
            playLive() {
                this.showPlayer = true;
                // 请求播放链接
                let _this = this;
                _this.$axios.post(common._BASE_ + '/live/getChannelLive',
                    _this.$qs.stringify({channelId: _this.channelId})).then(function (res) {
                    let r = res.data;
                    if (r.code !== 0) {
                        _this.$message({
                            message: r.message,
                            type: 'error'
                        })
                    } else {
                        if(_this.statInfo.vr){
                            _this.$message({
                                message: '暂不支持VR视频监控，正常播放效果至前台播放页面',
                                type: 'warning'
                            })
                        }
                        _this.source = r.uri;
                    }
                    // 获取聊天室配置
                    _this.$axios.post(common._BASE_ + '/chat/getSponsorConfig',
                        _this.$qs.stringify({cid: _this.channelId})).then(function (res) {
                        let r = res.data;
                        if (r.code === 0) {
                            _this.chatConfig = r.config;
                            _this.connectChatRoom(r.config);
                        }
                    });
                });
            },
            // 隐藏播放器，停止播放
            playerClosed() {
                this.$refs.AliplayerV2.pause();
                // 如果连接了聊天室，断开
                if(this.pingTimer){ clearInterval(this.pingTimer); }
                this.disconnectChatRoom();
            },
            handleClick(tab, event) {
                console.log(tab, event);
            },
            deleteStatistPrompt() {
                this.statistPromptFlag = false;
            },
            // 获取总体统计信息
            getChannelStatInfo() {
                let _this = this;
                _this.$axios.post(common._BASE_ + 'channel/statInfo',
                    this.$qs.stringify({channelId: _this.channelId})).then(function (res) {
                    let r = res.data;
                    if (r.code !== 0) {
                        _this.$message({
                            message: RESULT_MSG_MAPPER['' + Math.abs(r.code)],
                            type: 'error'
                        })
                    } else {
                        _this.statInfo = _this.formatStat(r.stat);
                        _this.activeTab = (r.stat.liveStatus === 'LIVING' ? 'MONITOR' : 'STAT');
                        // 如果正在直播，初始化直播监控图表
                        _this.activeTab === 'MONITOR' && _this.initMonitorCharts();
                        _this.activeTab === 'STAT' && _this.statRangeChanged();
                    }
                    _this.getMuteUser();
                });
            },
            /**
             * 根据录制Id获取统计信息
             */
            getChannelStatInfoByLive(lid) {
                let _this = this;
                _this.$axios.post(common._BASE_ + 'channel/statInfoByLid',
                    this.$qs.stringify({liveId: lid})).then(function (res) {
                    let r = res.data;
                    if (r.code !== 0) {
                        _this.$message({
                            message: RESULT_MSG_MAPPER['' + Math.abs(r.code)],
                            type: 'error'
                        })
                    } else {
                        _this.statInfo = _this.formatStat(r.stat);
                        _this.channelId = r.channelId;
                        _this.activeTab = 'STAT';
                        _this.statRange = '自定义';
                        _this.customRange = [r.start, r.end];

                        _this.getMuteUser();
                    }
                });
            },
            // 格式化总体统计信息
            formatStat(stat) {
                if (stat) {
                    // 总流量，分开数字和单位
                    let s = common.formatSize(stat.totalFlow);
                    stat.formatedFlow = s[0];
                    stat.formatedFlowUnit = s[1];
                    // 空间
                    s = common.formatSize(stat.space);
                    stat.formatedSpace = s[0];
                    stat.formatedSpaceUnit = s[1];
                    // 时长
                    stat.formatedDuration = (stat.duration / 3600).toFixed(1);
                    // 创建时间
                    stat.createTime = moment(stat.createTime).fromNow();
                }
                return stat;
            },
            // 初始化直播监控图表
            initMonitorCharts() {
                if (!this.monitorTimer) {
                    this.realTimeFrom = this.getRealTimeFrom();
                    this.monitorTimer = setInterval(() => {
                        this.queryLiveData()
                    }, MONITOR_STEP);
                    this.queryLiveData();
                }
            },
            // 计算实时监控的开始时间点
            getRealTimeFrom() {
                return parseInt((new Date()).getTime() / 1000) - PADDING - parseInt(MONITOR_STEP / 1000);
            },
            // 计算实时监控的截止时间点
            getRealTimeTo() {
                return parseInt((new Date()).getTime() / 1000) - PADDING;
            },
            /**
             * 请求直播监控数据
             */
            queryLiveData() {
                let _this = this;
                _this.$axios.post(common._BASE_ + 'live/rtData',
                    this.$qs.stringify({
                        channelId: _this.channelId,
                        from: _this.realTimeFrom,
                        to: _this.getRealTimeTo()
                    })).then(function (res) {
                    let r = res.data;
                    if (r.code !== 0) {
                        clearInterval(_this.monitorTimer);
                        _this.$notify({
                            title: '信息',
                            message: '监控已停止',
                            type: 'info'
                        });
                    } else {
                        _this.handleRealTimeData(r.data);
                    }
                });
            },
            /**
             * 加工实时监控数据
             * @param data 返回数据
             */
            handleRealTimeData(data) {
                if (!data) {
                    return;
                }

                let _this = this, cacheUv = _this.monitorUvOption.series[0].data,
                    cacheBandwidth = _this.monitorBandwidthOption.series[0].data;
                _this.realTimeFrom = data.to;

                // 裁剪缓存数据
                let t = parseInt(data.from) * 1000;
                cacheUv.length >= MAX_STAT_POINT && cacheUv.shift();
                cacheUv.push([t, data.userCount]);
                cacheBandwidth.length >= MAX_STAT_POINT && cacheBandwidth.shift();
                cacheBandwidth.push([t, data.bandwidth / 1000 / 1000]);
            },
            /**
             * 更改统计时段
             */
            statRangeChanged(){
                if(this.statRange !== '自定义'){
                    let type = this.PRESET_RANGE.indexOf(this.statRange);
                    if(type < 0){ return; }
                    // 请求数据
                    this.acquireStatData(type + 1);
                }
            },
            /**
             * 选定了自定义时间
             */
            customRangeChanged(){
                this.acquireStatData(CUSTOM_TYPE,
                    moment(this.customRange[0]).format('YYYY-MM-DD HH:mm:ss'),
                    moment(this.customRange[1]).format('YYYY-MM-DD HH:mm:ss'));
            },
            /**
             * 请求统计数据
             * @param type  预定义的时间段
             * @param from  自定义的
             * @param to
             */
            acquireStatData(type, from,to){
                let _this = this;
                _this.$axios.post(common._BASE_ + '/channel/statData',
                    this.$qs.stringify({
                        channelId: _this.channelId,
                        type: type,
                        from: from,
                        to: to
                    })).then(function (res) {
                    let r = res.data;
                    if (r.code !== 0) {
                        clearInterval(_this.monitorTimer);
                        _this.$notify({
                            title: '错误',
                            message: '获取统计信息失败',
                            type: 'error'
                        });
                    } else {
                        setTimeout(function(){
                            _this.handleStatData(r.stat);
                        }, 200);

                    }
                });
            },
            /**
             * 处理统计数据
             * @param statData
             */
            handleStatData(statData){
                if(!statData){ return; }

                let _this = this;
                _this.statPvOption.series[0].data = [];
                _this.statUvOption.series[0].data = [];
                _this.statBandwdithOption.series[0].data = [];

                (statData.stampDataList || []).forEach(function(item){
                    _this.statPvOption.series[0].data.push([item.stamp*1000, item.pv]);
                    _this.statUvOption.series[0].data.push([item.stamp*1000, item.uv]);
                    _this.statBandwdithOption.series[0].data.push([item.stamp*1000, parseInt(item.bandwidth)/1000/1000]);
                });
                // 格式化地图数据
                _this.statCityMapOption.series[0].data = [];
                let mapData = [], list = statData.mapDataList || [], max = 0;
                list.sort((firstItem, secondItem) => secondItem.userCount - firstItem.userCount);
                max = list.length>0? list[0].userCount: 1;
                list.forEach(function(item){
                   mapData.push(
                       {
                           name: item.city,
                           value: [].concat(item.longitude, item.latitude, item.userCount)
                       }
                   )
                });
                heatScale = max === 0?MAX_POINT_SIZE: MAX_POINT_SIZE/max;
                _this.statCityMapOption.series[0].data = mapData;
                _this.statCityMapOption.series[1].data = mapData.length>3? mapData.slice(0, 3): mapData;
            },

            /**
             * 连接聊天室
             * @param config
             */
            connectChatRoom(config){
                if(!config){ return; }

                let _this = this, uri;
                _this.disconnectChatRoom();
                uri = config.host + '/' + config.roomId + '/' + encodeURIComponent(config.userData);
                _this.webSocket = new WebSocket(uri);
                //与服务端建立连接触发
                _this.webSocket.onopen = function () {
                    console.log("与服务器成功建立连接");
                    _this.online = true;
                };
                //服务端推送消息触发
                _this.webSocket.onmessage = function (ev) {
                    _this.renderMessage(JSON.parse(ev.data));
                };
                //发生错误触发
                _this.webSocket.onerror = function () {
                    _this.$notify({
                        title: '错误',
                        message: '连接聊天服务失败',
                        type: 'error'
                    });
                    _this.online = false;
                };
                //正常关闭触发
                _this.webSocket.onclose = function () {
                    console.log("连接关闭");
                    _this.online = false;
                };
                if(_this.sendPing){
                    _this.pingTimer = setInterval(function(){
                        // 发送ping消息
                        _this.online && _this.webSocket.send(JSON.stringify({ message: '', type: 'ping'}));
                    }, 60000);
                }
            },

            /**
             * 显示消息
             */
            renderMessage(message){
                if(!message){ return; }

                let _this = this;
                if(_this.chatMessages.length > MAX_MESSAGE_COUNT){
                    _this.chatMessages.pop();
                }
                message.time = new Date();
                message.message = _this.replaceEm(message.message);
                _this.chatMessages.push(message);
                setTimeout(function(){
                    _this.scrollToBottom();
                }, 500);
            },

            /**
             * 滚动到最下面
             */
            scrollToBottom(){
                // 滚动到最下面
                let el = document.querySelector('.chat-room');

                if(el.scrollHeight - el.clientHeight - el.scrollTop < 200){
                    el.scrollTop = el.scrollHeight - el.clientHeight
                }
            },

            /**
             * 替换表情符号
             */
            replaceEm(str) {
                if(!str){ return str;}

                str = str.replace(/</g, '&lt;');
                str = str.replace(/>/g, '&gt;');
                str = str.replace(/\n/g, '<br/>');
                str = str.replace(/\[em_([0-9]*)\]/g, '<img src="/asserts/arclist/$1.gif" border="0" />');
                return str;
            },


            /**
             * 断开聊天室
             */
            disconnectChatRoom(){
                if(this.webSocket){
                    this.webSocket.close();
                    this.webSocket = null;
                }
            },

            /**
             * 发送消息
             */
            sendMessage(){
                if(this.chatInput === '' || !this.online){ return; }

                this.webSocket.send(JSON.stringify({ message: this.chatInput, type: 'text'}));
                this.chatInput = '';
            },

            /**
             * 聊天输入框输入了回车
             */
            inputEnter(e){
                if(e.ctrlKey){
                    this.sendMessage();
                }
            },

            /**
             * 选择文件发送
             */
            handleFileChange() {
                let _this = this,
                    file = _this.$refs.chat_file.files[0];
                if(!file){ return; }

                if(file.size > MAX_FILE_SIZE * 1024*1024){
                    _this.$notify({
                        title: '错误',
                        message: '文件过大，不能超过' + this.MAX_FILE_SIZE + 'MB',
                        type: 'error'
                    });
                    return;
                }

                let reader = null;
                if (window.FileReader) {
                    reader = new FileReader();
                } else {
                    _this.$notify({
                        title: '错误',
                        message: '设备不支持',
                        type: 'error'
                    });
                    return;
                }

                _this.$refs.chat_file.files = null;

                // 读图片数据
                reader.readAsDataURL(file);
                reader.onload = function() {
                    _this.readImage(3, this.result, {}, file.name, function(data, base64) {
                        _this.webSocket.send(JSON.stringify({ message: base64, type: 'image'}));
                    });
                }
            },

            /**
             * 绘制图片在canvas上获取数据
             * @param orientation 图片朝向
             * @param data  readAsDataURL读到的数据
             * @param obj   可指定图片的宽高
             * @param fileName 文件名
             * @param callback 回调
             */
            readImage(orientation, data, obj, fileName, callback){
                let img = new Image();
                img.src = data;

                img.onload = function() {
                    let that = this;
                    // 默认按比例压缩
                    let w = that.width,
                        h = that.height,
                        scale = w / h;

                    w = obj.width || w;
                    h = obj.height || (w / scale);

                    // 根据宽度进行缩放
                    let dw = Math.min(w, MAX_IMG_WIDTH);
                    h = Math.round(dw * h / w);
                    w = dw;

                    // 默认图片质量为1.0
                    let quality = 1.0;
                    //生成canvas
                    let canvas = document.createElement('canvas'),
                        cxt = canvas.getContext('2d');

                    canvas.width = w;
                    canvas.height = h;
                    // pc不需要旋转
                    cxt.drawImage(that, 0, 0, w, h);

                    // 图像质量
                    if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
                        quality = obj.quality;
                    }
                    // quality值越小，所绘制出的图像越模糊
                    let base64Img = canvas.toDataURL('image/jpeg', quality);
                    // 回调函数返回base64的值
                    callback(data, base64Img, fileName);
                }
            },

            /**
             * 禁言用户
             * @param user   用户
             * @param days   禁言天数
             */
            muteUser(user, days){
                let _this = this;
                _this.$axios.post(common._BASE_ + '/chat/mute',
                    this.$qs.stringify({
                        cid: _this.channelId,
                        openId: user.userId,
                        name: user.name,
                        days: days
                    })).then(function (res) {
                    let r = res.data;
                    if (r.code !== 0) {
                        _this.$notify({
                            title: '失败',
                            message: MUTE_RESULT_MAPPER[r.code+''],
                            type: 'error'
                        });
                    } else {
                        let msg = user.name + '被主播' + (days > 36500? '永久禁言' : ('禁言' + days + '天'));
                        _this.online && _this.webSocket.send(
                            JSON.stringify({
                                message: msg ,
                                type: 'instruction',
                                additional: JSON.stringify({userId: user.userId, action: 'mute'})
                            }));
                    }
                });
            },

            /**
             * 解除用户禁言
             * @param user
             */
            cancelMute(user){
                let _this = this;
                _this.$axios.post(common._BASE_ + '/chat/cancelMute',
                    this.$qs.stringify({
                        cid: _this.channelId,
                        openId: user.openId
                    })).then(function (res) {
                    let r = res.data;
                    if (r.code !== 0) {
                        _this.$notify({
                            title: '失败',
                            message: MUTE_RESULT_MAPPER[r.code + ''],
                            type: 'error'
                        });
                    } else {
                        for(let i=0; i<_this.muteUsers.length; i++){
                            if(_this.muteUsers[i].openId === user.openId){
                                _this.muteUsers.splice(i, 1);
                                break;
                            }
                        }
                    }
                });
            },

            /**
             * 获取当期频道的禁言用户
             */
            getMuteUser(){
                let _this = this;
                _this.$axios.post(common._BASE_ + '/chat/muteUsers',
                    this.$qs.stringify({
                        cid: _this.channelId
                    })).then(function (res) {
                    let r = res.data;
                    if (r.code !== 0) {
                        _this.$notify({
                            title: '失败',
                            message: '登录已过期',
                            type: 'error'
                        });
                    } else {
                        let now = new Date();
                        (r.users || []).forEach(function(item){
                            if(moment(item.muteTime).diff(now) > FOREVER_THRESHOLD){
                                item.muteTime = '永久';
                            }else{
                                item.muteTime = moment(item.muteTime).format('YYYY-MM-DD HH:mm');
                            }
                            _this.muteUsers.push(item);
                        });
                    }
                });
            },

            jumpNavPage(path) {
                this.$router.push({
                    path: path,
                    params: { cid: this.channelId },
                    query: {cid: this.channelId}
                });
            }

        },
        mounted() {
            //echarts.registerMap('china', chinaMap);

            let cid = this.$route.query.cid,
                lid = this.$route.query.lid;

            this.channelId = cid;
            if(lid && parseInt(lid) > 0){
                this.getChannelStatInfoByLive(lid);
            }else if (cid && parseInt(cid) > 0) {
                this.getChannelStatInfo();
            }
        },
        beforeDestroy() {
            if (this.monitorTimer) {
                clearInterval(this.monitorTimer);
            }
            if(this.pingTimer){
                clearInterval(this.pingTimer);
            }
            if (this.$refs.AliplayerV2) {
                this.$refs.AliplayerV2.dispose();
            }
        },
        watch:{
            statRange(){
                 this.statRangeChanged();
            },
            customRange(){
                this.customRangeChanged();
            }
        }

    };
</script> 

<style lang="less">
.liveStatistics {
    .overviewBox {
        width: 1210px;
        height: 139px;
        background: #ffffff;
        border: 1px solid #e8e8e8;
        margin-bottom: 17px;
        padding: 16px 24px;
        display: flex;

        .videoInfo {
            width: 500px;
            display: flex;
            // cursor: pointer;
            position: relative;

            .videoBtn {
                width: 32px;
                height: 32px;
                background: url("../../assets/playIcon.9baf1030.svg") no-repeat center center;
                background-size: 100% auto;
                border-radius: 50%;
                position: absolute;
                top: 0;
                bottom: 0;
                left: 72px;
                margin: auto 0;
                z-index: 2;
                transition: all 0.2s ease-out;
                opacity: 0;
                transform: scale(1.2);
                cursor: pointer;
            }

            .videoListImgIcon {
                width: 176px;
                height: 100px;
                overflow: hidden;
                margin-right: 20px;
                cursor: pointer;

                img {
                    max-width: 100%;
                    transition: all 0.4s;
                    -webkit-transition: all 0.4s;
                }
            }

            .liveName {
                height: 56px;
                font-size: 16px;
                line-height: 26px;
                color: #221816;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                margin-bottom: 28px;
                cursor: pointer;
            }

            .liveTime {
                font-size: 12px;
                color: #a2a9ab;
            }

            button{
                position: absolute;
                right:0;
                bottom: 0;
            }
        }

        .videoInfo:hover {
            .videoBtn {
                opacity: 1;
                -webkit-transform: scale(1);
                -moz-transform: scale(1);
                -ms-transform: scale(1);
                -o-transform: scale(1);
                transform: scale(1);
            }

            .videoListImgIcon {
                img {
                    transform: scale(1.06);
                    -webkit-transform: scale(1.06);
                }
            }

            .liveName {
                color: #306ff6;
            }
        }

        .balance {
            width: 700px;
            display: flex;

            .item {
                width: 224px;
                padding-left: 39px;
                padding-top: 20px;
                border-left: 1px solid #e8e8e8;
            }

            .last {
                margin-right: 0;
            }

            .middle {
                margin-right: 174px;
            }

            .title {
                font-size: 14px;
                font-weight: 400;
                color: #c1c5c5;
            }

            .number {
                font-size: 34px;
                font-weight: bold;
                color: #221816;
                margin-top: 6px;
                font-family: DIN Alternate;

                span {
                    font-size: 14px;
                    color: #221816;
                    margin-left: 12px;
                }
            }
        }
    }

    .tabsBox {
        border-bottom: solid 1px #306ff6;

        span {
            display: inline-block;
            width: 140px;
            height: 40px;
            border-radius: 6px 6px 0 0;
            background: #ffffff;
            text-align: center;
            line-height: 40px;
            font-size: 14px;
            margin-right: 15px;
            border: solid 1px #e8e8e8;
            border-bottom: none;
            color: #221816;
            cursor: pointer;
        }

        span.active {
            background: #306ff6;
            color: #fff;
            border: solid 1px #306ff6;
        }
    }

    .MonitorStatistical {
        padding-bottom: 80px;
        .statistPrompt {
            width: 1210px;
            height: 65px;
            background: #fffdef;
            border-radius: 4px;
            margin: 16px 0 8px 0;
            padding: 0 18px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .SPText {
                width: 1100px;
            }

            .SPCloseBtn {
                cursor: pointer;
            }
        }

        .advanceds {
            width: 1210px;
            background: #ffffff;
            border: 1px solid #e8e8e8;
            margin: 15px 0;

            .tipsBox {
                height: 44px;
                margin: 0 25px;
                display: flex;
                align-items: center;
                font-size: 12px;
                font-weight: 400;
                line-height: 26px;
                color: #7e868c;
                border-bottom: 1px dashed #e8e8e8;

                img {
                    margin-right: 6px;
                }
            }

            .title {
                height: 44px;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid #e9e9e9;
                padding: 0 21px;
                font-size: 16px;
                font-weight: bold;
                color: #221816;
                position: relative;

                span::before {
                    content: "";
                    display: inline-block;
                    width: 4px;
                    height: 12px;
                    background: #306ff6;
                    border-radius: 3px;
                    margin-right: 6px;
                }

                .buttonBox {
                    position: absolute;
                    right: 16px;

                    button {
                        width: 80px;
                        height: 25px;
                        border-radius: 4px;
                        font-size: 12px;
                        font-weight: 400;
                        margin-left: 9px;
                    }

                    .download {
                        background: #076eff;
                        color: #fff;
                    }

                    .download:hover {
                        background: #4aa3f8;
                    }

                    .report {
                        background: #ffffff;
                        border: 1px solid #c1c5c5;
                        color: #221816;
                    }

                    .report:hover {
                        background: #076eff;
                        color: #fff;
                        border: none;
                    }
                }
            }

            .linechart {
                padding: 23px 0;
            }
        }

        .el-tabs__item {
            width: 140px;
            height: 40px;
            border-radius: 6px 6px 0px 0px;
            text-align: center;
            background: #ffffff;
            font-size: 14px;
            font-weight: 400;
            color: #221816;
            margin-right: 15px;
        }

        .is-active {
            background: #306ff6;
            color: #fff;
        }

        .el-tabs__item.is-active {
            color: #fff;
        }

        .el-tabs__header {
            border-bottom: none !important;
        }

        .el-tabs__nav-scroll {
            border-bottom: solid 1px #306ff6 !important;
        }

        .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
            border-bottom-color: transparent;
        }

        .el-tabs--card>.el-tabs__header .el-tabs__nav {
            border: none;
        }

        .line-chart{
            width: 100%;
            min-height: 400px;
        }
    }

    .chat-container{
        display: flex;
        flex-direction: column;
        height: 100%;

        .chat-room{
            width: 100%;
            overflow-y: auto;
            //margin-bottom: 200px
            flex: 1;
            padding-left: 20px;
        }
        .input-panel{
            width:640px;
            height: 160px;
        }

        .chatItem {
            display: flex;
            font-size: 12px;
            font-weight: 400;
            color: #8f8f8f;
            margin: 20px auto;

            .chat {
                max-width: 246px;
            }

            .user {
                max-width: 36px;
                max-height: 36px;
            }

            .name {
                margin-bottom: 10px;
                cursor: pointer;
            }

            .user {
                margin-right: 9px;
            }

            .text {
                word-break: break-all;
                display: inline-block;
                padding: 13px;
                background: #f0f0f0;
                border-radius: 4px;
                font-size: 12px;
                font-weight: 400;
                color: #000;
            }

            .tag {
                padding: 3px 11px;
                background: #2196f3;
                border-radius: 4px;
                font-size: 14px;
                font-weight: 400;
                line-height: 0;
                color: #ffffff;
            }

            img {
                border-radius: 4px;
                object-fit: cover;
            }

            .img{
                width: 192px;
                padding: 11px;
                background: #f0f0f0;
                border-radius: 4px;

                img{
                    width: 100%;
                }
            }
        }

        .webuploader{
            display: none;
        }
    }
}
</style>